<template>
  <div class="seach-form">
    <el-row
      v-for="(row, indexOne) in rowCols"
      :key="'search-row-' + indexOne"
      class="each-row"
      :gutter="10"
    >
      <el-col
        v-for="(col, indexTwo) in row"
        :key="'search-col-' + indexTwo"
        :span="(24 / colNum) * col.span"
        class="each-col"
      >
        <div class="f-c each-input">
          <span class="title">{{ col.label }}</span>
          <div class="input">
            <el-input
              :class="{
                'customize-number-input': col.inputAccept === 'mnumber'
              }"
              v-if="col.type === TextInput || col.type === NumberInput"
              size="small"
              :type="col.inputAccept || 'text'"
              :value="searchForm[col.key].value"
              clearable
              @input="val => formValueChange(col, 'value', val)"
            >
              <template slot="prepend" v-if="col.prepend === PrependText">
                {{ col.prependValue }}
              </template>
              <el-select
                :value="searchForm[col.key].prependValue"
                slot="prepend"
                class="prepend-select"
                v-else-if="col.prepend === PrependSelect"
                @change="val => formValueChange(col, 'prependValue', val)"
              >
                <el-option
                  v-for="item in col.prependOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-input>
            <el-select
              v-else-if="col.type === Select"
              size="small"
              clearable
              :multiple="col.multiple"
              :value="searchForm[col.key].value"
              @input="val => formValueChange(col, 'value', val)"
              :disabled="col.options.length === 1"
            >
              <el-option
                v-for="item in col.options"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
            <address-pick
              v-else-if="col.type === AddressSelect"
              :value="searchForm[col.key].value"
              @input="val => formValueChange(col, 'value', val)"
            />
            <el-date-picker
              size="small"
              v-else-if="col.type === TimeRange"
              clearable
              :disabled="col.disabled"
              type="datetimerange"
              range-separator="To"
              start-placeholder="Start date"
              end-placeholder="End date"
              :value="searchForm[col.key].value"
              @input="val => formValueChange(col, 'value', val)"
            />
            <el-date-picker
              size="small"
              v-else-if="col.type === TimeSelect"
              clearable
              type="datetime"
              placeholder="Select date and time"
              :value="searchForm[col.key].value"
              @input="val => formValueChange(col, 'value', val)"
            />
            <el-select
              v-else-if="col.type === RemoteSelect"
              size="small"
              remote
              filterable
              clearable
              :loading="col.loading"
              placeholder="Type to search"
              :value="searchForm[col.key].value"
              :remote-method="col.method.bind(col)"
              @change="val => formValueChange(col, 'value', val)"
            >
              <el-option
                v-for="item in col.options"
                :key="item.key"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { FormTypeMixin } from '@/core/mixin/form'
import { FormModes, SearchFormRowColsCal } from '@/core/configs/types'
import AddressPick from '@/components/address/AddressPick.vue'
export default {
  name: 'SearchForm',
  components: { AddressPick },
  props: {
    mode: {
      type: Object,
      default: () => {
        return FormModes.NORMAL
      }
    },
    searchForm: {
      type: Object,
      required: true
    },
    searchFormChange: {
      type: Function,
      required: true
    }
  },
  mixins: [FormTypeMixin],
  data() {
    return {
      rowCols: []
    }
  },
  methods: {
    formValueChange(header, path, value) {
      // 1. validate change
      for (const validate of header?.validators ?? []) {
        const [flag, msg] = validate(value)
        if (!flag) {
          this.$message.error(msg)
          return
        }
      }
      // 2. callback
      this.searchFormChange(header.key, path, value)
    }
  },
  watch: {
    searchFormTypes: {
      handler() {
        const rowCols = SearchFormRowColsCal(
          Object.values(this.searchForm),
          this.colNum
        )
        this.$set(this, 'rowCols', rowCols)
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    searchFormTypes() {
      return Object.values(this.searchForm).map(one => [one.key, one.type])
    },
    colNum() {
      return this.mode.cols
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.search-form {
  width: 100%;

  @extend .f-c;
}

.each-input {
  padding: 5px 0;
  gap: 5px;

  .title {
    font-size: $regular-body-font-size !important;
    text-align: start;
  }

  .input {
    flex-grow: 1;

    .el-select,
    .el-date-picker,
    .el-date-editor,
    .el-input,
    .el-input-number {
      width: 100%;
    }
  }

  .prepend-select {
    width: 80px !important;
  }
}

::v-deep .el-input-group__prepend .el-input__suffix {
  position: absolute;
  right: 0;
}
</style>

<style lang="scss">
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  appearance: none;
  margin: 0;
}
</style>
